/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: '#dbd6c8',
    className: null,
};

const TwitterIcon = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlnsA="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
        x="0px"
        y="0px"
        width="24.6px"
        height="20px"
        viewBox="0 0 33.8 27.5"
        xmlSpace="preserve"
        className={className}
    >
        <g>
            <path
                fill={color}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.4,6.8c0,0.3,0,0.6,0,0.9c0,9.2-7,19.8-19.8,19.8c-3.9,0-7.6-1.1-10.6-3.1c0.5,0.1,1.1,0.1,1.7,0.1
		c3.3,0,6.2-1.1,8.6-3c-3-0.1-5.6-2.1-6.5-4.8c0.4,0.1,0.9,0.1,1.3,0.1c0.6,0,1.2-0.1,1.8-0.2c-3.2-0.6-5.6-3.4-5.6-6.8
		c0,0,0-0.1,0-0.1c0.9,0.5,2,0.8,3.1,0.9C2.6,9.3,1.4,7.2,1.4,4.8c0-1.3,0.3-2.5,0.9-3.5c3.4,4.2,8.5,7,14.3,7.3
		c-0.1-0.5-0.2-1-0.2-1.6c0-3.8,3.1-6.9,6.9-6.9c2,0,3.8,0.8,5.1,2.2c1.6-0.3,3.1-0.9,4.4-1.7c-0.5,1.6-1.6,3-3.1,3.8
		c1.4-0.2,2.7-0.5,4-1.1C32.9,4.6,31.7,5.9,30.4,6.8"
            />
        </g>
    </svg>
);

TwitterIcon.propTypes = propTypes;
TwitterIcon.defaultProps = defaultProps;

export default TwitterIcon;
